<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :idAsociados="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="10"
              >
                <v-text-field
                  v-model="form.ruc_associate"
                  :rules="[rules.required, rules.rucLength, rules.rucFormat]"
                  label="Número de Identificación"
                  maxlength="20"
                  placeholder="RUC o Cédula"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="themeColor"
                      @click="searchDV"
                      v-on="on"
                      :loading="searching"
                    >
                      <v-icon
                        text
                      >
                        mdi-account-search
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Buscar</span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.ruc_type_associate"
                  :items="items_type"
                  :rules="[rules.required]"
                  label="Tipo de Contribuyente"
                  placeholder="Natural o Jurídico"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.dv_associate"
                  :rules="[rules.required, rules.numeric]"
                  label="Dígito Verificador"
                  maxlength="5"
                  placeholder="59"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.name_associate"
                  :rules="[rules.required]"
                  maxlength="100"
                  label="Razón Social"
                  :placeholder="razonSocialPlaceholder"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.email_associate"
                  :rules="[rules.emailFormat]"
                  maxlength="100"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import { mapGetters } from 'vuex';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },

    props: {
      id: { default: '' },
      idAsociados: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        ruc_associate: '',
        ruc_type_associate: '',
        dv_associate: '',
        name_associate: '',
        email_associate: '',
        status: '1',
        active: '1',
        busy: false,
      }),
      items_type: [
        { value: 1, text: 'NATURAL' },
        { value: 2, text: 'JURÍDICO' },
      ],
      valid: false,
      searching: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
        rucLength: (v) => (v.length >= 5 && v.length <= 20) || 'El campo debe tener de 5 a 20 caracteres.',
        rucFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || 'El campo debe tener un formato válido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Asociado',
      apiURL: '/api/enterprises',
      apiURLPartners: 'partners/store',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
      razonSocialPlaceholder() {
        return process.env.VUE_APP_ENV === 'HKA'
          ? 'The Factory HKA CORP'
          : 'Electronic Business Intelligence en Panamá';
      },
      addressPlaceholder() {
        return process.env.VUE_APP_ENV === 'HKA'
          ? 'Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá'
          : 'Edificio W50, C. 76 Este, Panamá';
      },
    },
    async mounted() {
      const URL = `${this.apiURL}/${this.id}/${this.apiURLPartners}`;
      this.URL = URL;
      if (this.idAsociados) {
        window.axios.get(`/api/enterprises/${this.id}/partners/${this.idAsociados}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `/api/enterprises/${this.id}/partners/${this.idAsociados}/update`;
          this.method = 'PUT';
          this.title = 'Editar Asociado';
          this.message = `Se ha editado la empresa ${result.data.name_associate} exitosamente.`;
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then((result) => {
         this.$router.push({
        name: 'partners',
        params: {
        id: this.enterprise_id, pac_id: this.empresaPAC, ruc: this.empresaRUC, action: 'created', message: result.data.message,
        },
        });
        }).catch(() => {
            this.form.busy = false;
        });
      },
      searchDV() {
        if (this.form.ruc_type_associate) {
          if (this.form.ruc_associate) {
            this.searching = true;
            const url = `/api/enterprises/getDV/${this.form.ruc_associate}/${this.form.ruc_type_associate}`;
            window.axios.post(url)
            .then((response) => {
              let messageType = 'error';
              if (response.data.ConsultarRucDVResult.codigo === '200') {
                  this.form.dv_associate = response.data.ConsultarRucDVResult.infoRuc.dv;
                  this.form.name_associate = response.data.ConsultarRucDVResult.infoRuc.razonSocial;
                  messageType = 'success';
              }
              this.$store.dispatch('notifications/show', {
                message: response.data.ConsultarRucDVResult.mensaje,
                type: messageType,
              });
              this.searching = false;
            });
          } else {
            this.$store.dispatch('notifications/show', {
              message: 'Introduzca un número de identificación.',
              type: 'error',
            });
          }
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'Seleccione un tipo de contribuyente.',
            type: 'error',
          });
        }
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
